/******************************************************************
 * Archivo : client/src/components/Admin/roles/AllRoles.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Visualizar todos los roles registrados en el sistema.
 *
 * Compatible con:
 * React 16.x
 * Apollo 2.x
 ******************************************************************/

import React, { useState } from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";
import toggleRole from "../../../mutations/toggleRole";

// Iconos
import FaSearch from "react-icons/lib/fa/search";
import FaPlus from "react-icons/lib/fa/plus";
import FaEdit from "react-icons/lib/fa/pencil";
import FaPowerOff from "react-icons/lib/fa/power-off";

// Query
import query from "../../../queries/fetchAllRoles";

const AllRoles = props => {

  const [search, setSearch] = useState("");

  if (props.data.loading) {
    return (
      <div className="loader">
        Cargando Roles...
      </div>
    );
  }

  let roles = props.data.roles || [];

  roles = roles.filter(role => {

    const text = search.toLowerCase();

    return (
      role.code.toLowerCase().includes(text) ||
      role.label.toLowerCase().includes(text) ||
      (role.description || "")
        .toLowerCase()
        .includes(text)
    );

  });

  const handleToggle = async id => {

  await props.toggleRole({

    variables: {
      id
    }

  });

};

  return (

    <div className="container">

      <div className="row mb-4">

        <div className="col-md-8">

          <h2>Administración de Roles</h2>

          <p className="text-muted">
            Gestione los roles disponibles dentro del sistema.
          </p>

        </div>

        <div className="col-md-4 text-right">

          <Link
            to="/admin/roles/new"
            className="btn btn-primary"
          >
            <FaPlus />
            {" "}
            Nuevo Rol
          </Link>

        </div>

      </div>

      <div className="row mb-3">

        <div className="col-md-6">

          <div className="input-group">

            <div className="input-group-prepend">

              <span className="input-group-text">

                <FaSearch />

              </span>

            </div>

            <input
              type="text"
              className="form-control"
              placeholder="Buscar por código, nombre o descripción..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />

          </div>

        </div>

      </div>

      <table className="table table-hover table-striped">

        <thead>

          <tr>

            <th>Código</th>

            <th>Nombre</th>

            <th>Descripción</th>

            <th>Estado</th>

            <th width="120">
              Acciones
            </th>

          </tr>

        </thead>

        <tbody>

          {
            roles.length === 0
              ?

              <tr>

                <td
                  colSpan="5"
                  className="text-center text-muted"
                >

                  No existen roles registrados.

                </td>

              </tr>

              :
                            roles.map(role => (

                <tr key={role.id || role._id}>

                  <td>

                    <strong>
                      {role.code}
                    </strong>

                  </td>

                  <td>

                    {role.label}

                  </td>

                  <td>

                    {role.description || "-"}

                  </td>

                  <td>

                    {
                      role.active
                        ?
                        <span className="badge badge-success">
                          Activo
                        </span>
                        :
                        <span className="badge badge-secondary">
                          Inactivo
                        </span>
                    }

                  </td>

                  <td>

                    <Link
                    to={`/admin/roles/${role.id || role._id}`}
                    className="btn btn-sm btn-outline-primary mr-2"
                    title="Editar"
                    >

                  <FaEdit />

                    </Link>
                    <button
                      type="button"
                      className={
                        role.active
                        ? "btn btn-sm btn-outline-success"
                        : "btn btn-sm btn-outline-danger"
                      }
                      title={
                        role.active
                        ? "Inactivar"
                        : "Activar"
                      }
                      onClick={() => handleToggle(role.id || role._id)}
                    >

                  <FaPowerOff />

                      </button>

                  </td>

                </tr>

              ))

          }

        </tbody>

      </table>

      <div className="text-muted">

        Total de Roles: <strong>{roles.length}</strong>

      </div>

    </div>

  );

};

export default graphql(toggleRole, {
  name: "toggleRole",
  options: {
    refetchQueries: [{ query }]
  }
})(
  graphql(query)(AllRoles)
);


// WEBPACK FOOTER //
// ./src/components/Admin/roles/AllRoles.js